import { ValidPlanType } from '../components/FactorialF25Bundles/types'

export type PlanByIndustryType = {
  [industry: string]: {
    plan: string
    recommended_addons: string[]
  }
}

const planByIndustry: PlanByIndustryType = {
  health_and_pharma: {
    plan: 'productivity',
    recommended_addons: ['recruitment', 'expenses'],
  },
  professional_services: {
    plan: 'consulting',
    recommended_addons: ['recruitment', 'expenses'],
  },
  public_non_profit_org: {
    plan: 'essentials',
    recommended_addons: ['recruitment', 'expenses', 'project'],
  },
  hospitality: {
    plan: 'planning',
    recommended_addons: ['recruitment', 'expenses'],
  },
  retail: {
    plan: 'planning',
    recommended_addons: ['recruitment', 'expenses'],
  },
  construction: {
    plan: 'consulting',
    recommended_addons: ['shift', 'expenses'],
  },
  tech_and_telecommunications: {
    plan: 'productivity',
    recommended_addons: ['recruitment', 'expenses'],
  },
  industrial_companies: {
    plan: 'planning',
    recommended_addons: ['recruitment', 'project'],
  },
  default: {
    plan: 'essentials',
    recommended_addons: ['recruitment'],
  },
}

const industryMapping: { [industry: string]: keyof PlanByIndustryType } = {
  aerospace_defense: 'industrial_companies',
  agriculture: 'default',
  automobiles_components: 'industrial_companies',
  banking_insurance: 'professional_services',
  chemicals: 'industrial_companies',
  commercial_services: 'professional_services',
  commodities: 'default',
  construction_engineering: 'construction',
  consumer_durables_apparel: 'default',
  consumer_services: 'default',
  containers_packaging: 'industrial_companies',
  diversified_financials: 'professional_services',
  education: 'public_non_profit_org',
  energy: 'industrial_companies',
  food_staples_retailing: 'default',
  food_beverage_tobacco: 'default',
  government_administration: 'public_non_profit_org',
  healt_care_equipment_services: 'health_and_pharma',
  hospitality: 'hospitality',
  internet_direct_marketing_retails: 'tech_and_telecommunications',
  legal_services: 'professional_services',
  machinery: 'industrial_companies',
  manufacturing: 'industrial_companies',
  media_entertainment: 'default',
  metals_mining: 'industrial_companies',
  military: 'public_non_profit_org',
  other: 'default',
  non_profit_org: 'public_non_profit_org',
  pharmaceuticals_biotechnology: 'health_and_pharma',
  real_estate: 'default',
  research_consulting: 'professional_services',
  retailing: 'retail',
  semiconductors: 'tech_and_telecommunications',
  software_it_services: 'tech_and_telecommunications',
  tech_hardware_equipment: 'tech_and_telecommunications',
  telecommunication: 'tech_and_telecommunications',
  trading_distributors: 'professional_services',
  transportation: 'default',
  travel_tourism: 'default',
  utilities: 'industrial_companies',
}

export function getPlanByIndustry(industry: string) {
  const mappedIndustry = industryMapping[industry] || 'default'
  return planByIndustry[mappedIndustry]
}

export function getPlanTypeByCountry(country: string): ValidPlanType {
  const ENTERPRISE_COUNTRIES = ['fr', 'it', 'de']
  if (ENTERPRISE_COUNTRIES.includes(country.toLowerCase())) {
    return 'enterprise'
  }
  return 'business'
}

export function getFloorByCountry(country: string): number {
  if (['es', 'it', 'pt'].includes(country)) return 19
  if (['fr', 'de', 'gb'].includes(country)) return 14
  if (['us', 'ca'].includes(country)) return 10
  return 14
}

export function getSelfServedByCountry(country: string): number {
  if (['es', 'it', 'fr'].includes(country)) return 19
  if (['pt', 'de', 'gb'].includes(country)) return 14
  return 14
}
